<template>
  <v-dialog
    :value="value"
    max-width="560"
    @input="$emit('input', $event)"
  >
    <v-card>
      <div class="modal-container">
        <button class="btn-close" @click="onClose">
          <v-icon class="icon-close">mdi-close</v-icon>
        </button>

        <div class="modal-header">
          <div class="info-icon" :style="iconCircleStyle">
            <v-icon color="primary" size="24">
              mdi-information-outline
            </v-icon>
          </div>

          <div class="header-headline">วิธีกรอกโค้ด TRD</div>
        </div>

        <div class="modal-body">
          <div class="method">
            <div class="method-header">
              <div class="method-icon" :style="iconCircleStyle">
                <v-icon color="primary" size="18">
                  mdi-qrcode-scan
                </v-icon>
              </div>
              <div class="method-title">สแกนโค้ด TRD</div>
            </div>
            <p class="method-desc">
              กดปุ่ม
              <v-icon size="16" color="rgba(0,0,0,0.45)">
                mdi-qrcode-scan
              </v-icon>
              สแกนโค้ด TRD เพื่อสแกน QR Code จากเอกสาร Trade-in
              ได้ทันที
            </p>

            <div class="hint-image">
              <div class="hint-image-caption">
                ตัวอย่างตำแหน่งโค้ดในเอกสาร
              </div>
              <img
                src="@/assets/hint-trd-code.webp"
                alt="ตำแหน่งโค้ด TRD บนเอกสาร"
              />
            </div>
          </div>

          <div class="divider-or"><span>หรือ</span></div>

          <div class="method">
            <div class="method-header">
              <div class="method-icon" :style="iconCircleStyle">
                <v-icon color="primary" size="18">
                  mdi-keyboard-outline
                </v-icon>
              </div>
              <div class="method-title">กรอกโค้ด TRD ด้วยตนเอง</div>
            </div>
            <p class="method-desc">
              นำเลขที่เอกสารเทรดและหมายเลขโทรศัพท์ที่ใช้ทำรายการมาต่อกัน
            </p>

            <div class="formula">
              <div class="formula-chip">
                <div class="formula-value">TRD2609-00001-00001</div>
                <div class="formula-label">เลขที่เอกสารเทรด</div>
              </div>

              <v-icon size="16" color="rgba(0,0,0,0.35)">
                mdi-plus
              </v-icon>

              <div class="formula-chip">
                <div class="formula-value">0989999999</div>
                <div class="formula-label">หมายเลขโทรศัพท์</div>
              </div>

              <v-icon size="16" color="rgba(0,0,0,0.35)">
                mdi-equal
              </v-icon>

              <div
                class="formula-chip -is-result"
                :style="resultChipStyle"
              >
                <div class="formula-value">
                  TRD2609-00001-0000109899999999
                </div>
                <div class="formula-label">โค้ด TRD ของคุณ</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <v-btn
            depressed
            rounded
            block
            large
            dark
            color="primary"
            @click="onClose"
          >
            เข้าใจแล้ว
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  name: 'BaseTradeInVoucherHelpModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      colorBnn,
    }
  },

  computed: {
    iconCircleStyle() {
      return {
        backgroundColor: colorBnn['color-bnn-light'],
      }
    },

    resultChipStyle() {
      return {
        borderColor: colorBnn['color-bnn'],
      }
    },
  },

  methods: {
    onClose() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-close {
    position: absolute;
    top: 16px;
    right: 16px;

    width: 40px;
    height: 40px;
    background: #e8e8e8;
    border-radius: 50% !important;

    &:hover {
        .icon-close {
            color: rgba(0, 0, 0, 0.72);
        }
    }

    .icon-close {
        color: rgba(18, 18, 18, 0.56);
    }
}

.modal-header {
    padding: 24px 24px 16px;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .info-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 48px;
        height: 48px;
        border-radius: 50%;
    }

    .header-headline {
        font-size: 18px;
        font-weight: 700;
        color: rgba(#000000, 0.85);
    }
}

.modal-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 24px 16px;
}

.method {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.method-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.method-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    width: 28px;
    height: 28px;
    border-radius: 50%;
}

.method-title {
    font-size: 15px;
    font-weight: 700;
    color: rgba(#000000, 0.85);
}

.method-desc {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(#000000, 0.65);

    .v-icon {
        vertical-align: middle;
        margin: 0 2px;
    }
}

.divider-or {
    display: flex;
    align-items: center;
    gap: 12px;

    color: rgba(#000000, 0.35);
    font-size: 12px;

    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background-color: #E0E0E0;
    }
}

.formula {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;

    padding: 12px;
    background-color: #F8F8FA;
    border-radius: 8px;
}

.formula-chip {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    padding: 6px 10px;
    background-color: #ffffff;
    border: 1px solid #E0E0E0;
    border-radius: 6px;

	&.-is-result {
		background-color: #0071e30d;
	}

    .formula-value {
        font-family: 'SF Mono', 'Roboto Mono', monospace;
        font-size: 12px;
        font-weight: 600;
        color: rgba(#000000, 0.85);
        word-break: break-all;
        text-align: center;
    }

    .formula-label {
        font-size: 11px;
        color: rgba(#000000, 0.45);
    }
}

.hint-image {
	display: flex;
	flex-direction: column;
	align-items: center;
    margin-top: 4px;

    img {
        display: block;
        width: 100%;
		max-width: 540px;
    }

    .hint-image-caption {
        margin-top: 6px;
        font-size: 12px;
        text-align: center;
        color: rgba(#000000, 0.45);
    }
}

.modal-footer {
    padding: 8px 24px 24px;
}

.modal-container {
	position: relative;
	overflow: auto;
	max-height: 75vh;
}
</style>
